import { AuditChannel } from "@common/types/auditLog";

export const AGENT_CHANNEL_HEADER = "x-kick-agent-channel";

export enum AgentChannel {
    AGENT_RUN = "agent-run",
    MCP = "mcp",
    CLI = "cli",
}

export function parseAgentChannel(
    value: string | string[] | undefined,
): AgentChannel | undefined {
    if (typeof value !== "string") {
        return undefined;
    }
    return Object.values(AgentChannel).find((channel) => channel === value);
}

export const AUDIT_CHANNEL_LABELS: Record<AuditChannel, string> = {
    [AuditChannel.WEB]: "Web",
    [AuditChannel.MCP]: "MCP",
    [AuditChannel.CLI]: "CLI",
    [AuditChannel.API]: "API",
    [AuditChannel.AGENT]: "Agent",
    [AuditChannel.SYSTEM]: "System",
};

export const NO_HISTORY_CHANNEL = "none";

export type HistoryDetailsChannel = AuditChannel | typeof NO_HISTORY_CHANNEL;
